import { render } from "./list-objective.vue?vue&type=template&id=a089b416&ts=true"
import script from "./list-objective.vue?vue&type=script&lang=ts"
export * from "./list-objective.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__